import React, { ComponentProps } from "react";

function AxeIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={30}
      height={31}
      viewBox="0 0 30 31"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.951172" width={30} height={30} rx={8} fillOpacity="0.2" />
      <path
        opacity="0.4"
        d="M6.81301 15.3156C6.41704 15.0731 5.93512 15.3032 5.93824 15.7544C5.95076 18.0075 6.88724 20.3496 8.7138 22.1762C10.5404 24.0028 12.8825 24.9392 15.1356 24.9518C15.5868 24.9549 15.8169 24.473 15.5744 24.077C15.1511 23.3883 14.9019 22.6398 14.8284 21.8961C14.7063 20.6609 15.2303 19.448 16.1079 18.5703L12.3197 14.7821C11.442 15.6597 10.229 16.1837 8.99386 16.0616C8.2502 15.9881 7.50169 15.7389 6.81301 15.3156ZM20.5208 8.8404C18.8408 7.49693 16.8436 6.80614 14.9123 6.79858C14.4618 6.79686 14.2114 7.29861 14.4464 7.683C14.9167 8.45236 15.1689 9.29752 15.2019 10.1283C15.2474 11.2744 14.7298 12.3719 13.9188 13.183L13.8911 13.2106L17.6794 16.9989L17.707 16.9712C18.5181 16.1602 19.6156 15.6426 20.7617 15.6881C21.5925 15.7211 22.4376 15.9733 23.207 16.4436C23.5913 16.6785 24.0931 16.4282 24.0914 15.9776C24.0839 14.0464 23.3931 12.0492 22.0496 10.3692L19.7445 11.1455L20.5208 8.8404Z"
      />
      <path d="M12.6418 11.9623L23.2489 22.5695C23.4659 22.7864 23.4659 23.1382 23.2489 23.3552L22.4632 24.1409C22.2463 24.3579 21.8945 24.3579 21.6775 24.1409L11.0704 13.5338C10.6364 13.0998 10.6365 12.3962 11.0704 11.9623C11.5043 11.5284 12.2079 11.5284 12.6418 11.9623Z" />
    </svg>
  );
}

export default AxeIcon;
